export const getPlacementGradientStyles = (/* theme */) => ({
  placementCardGradientRoot: {
    display: 'block',
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
});
